import type { IconNode } from '../types';

/**
 * @name meal-box
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHg9IjIiIHk9IjIiIHJ4PSI2IiAvPgogIDxwYXRoIGQ9Ik0yMiAxMmMwIDMuMy0yLjcgNi02IDZIOGMtMy4zIDAtNi0yLjctNi02IiAvPgogIDxwYXRoIGQ9Ik03IDZoMTAiIC8+CiAgPHJlY3Qgd2lkdGg9IjQiIGhlaWdodD0iNCIgeD0iNiIgeT0iMTAiIHJ4PSIxIiAvPgogIDxyZWN0IHdpZHRoPSI0IiBoZWlnaHQ9IjQiIHg9IjE0IiB5PSIxMCIgcng9IjEiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/meal-box
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const mealBox: IconNode = [
  ['rect', { width: '20', height: '20', x: '2', y: '2', rx: '6', key: '1jp5ib' }],
  ['path', { d: 'M22 12c0 3.3-2.7 6-6 6H8c-3.3 0-6-2.7-6-6', key: 't0pv61' }],
  ['path', { d: 'M7 6h10', key: '1bwv94' }],
  ['rect', { width: '4', height: '4', x: '6', y: '10', rx: '1', key: '1mtm3b' }],
  ['rect', { width: '4', height: '4', x: '14', y: '10', rx: '1', key: 'wewuac' }],
];

export default mealBox;
